import React, { Component } from 'react';
import { Icon, AutoComplete, tip, TooltipController } from '@itglue/kaseya-ui';
import { VideoCard } from './components/VideoCard';
import { SingleVideoView } from './components/SingleVideoView';
import { InAppSidebar, findIframes } from './components/InAppSidebar';
import classnames from 'classnames';

interface VimeoData {
    name: string;
    iframe: string;
    description?: string;
    tags?: string[];
}
interface TagColors {
    [key: string]: string;
}
export interface LightboxProps {
    className?: string;
    onEsc?(): void;
    dataVimeo?: VimeoData[];
    onEnter?(): void;
    onClose?(): void;
    onClick?(e: React.MouseEvent<HTMLElement>): void;
    sidebar?: boolean;
    supportSingleVideoView?: boolean;
    tagColors?: TagColors;
    tooltip?: string;
    singleVideoViewSidebar?: boolean;
}

export class InAppVideos extends Component<LightboxProps> {

    static defaultProps = {
        sidebar: 'True',
        supportSingleVideoView: 'True',
        singleVideoViewSidebar: 'True',
    };

    state = {
        selectedVideo: undefined,
        filteredData: null,
        filteredDataSidebar: null,
        searchSidebar: false,
        singleVideoView: false,
        active: false,
        item: null,
        tooltip: null,
        searchTagsOnSidebar: false,
        singleVideo: null,
        singleVideoIndex: null,
        singleVideoSidebarList: null,
        tooltipsList: null,
    };

    private tooltip: TooltipController | undefined;

    private handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
        this.props.onClick?.(e);
        this.props.onClose?.();
    }

    private handleClickBackground = (e: React.MouseEvent<HTMLDivElement>) => {
        this.props.onClick?.(e);
        if ((e.target as HTMLButtonElement).className === 'kaseya-ui-in-app-videos') {
            this.props.onClose?.();
        }
    }

    private handleVideoClick = (e: React.MouseEvent<HTMLDivElement>, video: any, index: any) => {
        this.props.onClick?.(e);
        // this.destroyTooltip();
        if (this.props.supportSingleVideoView) {
            this.setState({ singleVideoView: true, singleVideo: video, singleVideoIndex: index });

        }
    }

    private handleReturn = (e: React.MouseEvent<HTMLDivElement>) => {
        this.props.onClick?.(e);
        this.setState({ singleVideoView: false });
    }

    private handleEsc = () => {
        this.props.onEsc?.();
        this.props.onClose?.();
    }

    private handleEnter = () => {
        this.props.onEnter?.();
    }

    private handleMouseDown = (e: React.MouseEvent<HTMLDivElement>) => {
        e.stopPropagation();
    }

    private timer: ReturnType<typeof setTimeout> | undefined;

    private doSearch (event: any) {

        let filteredData: VimeoData[] | undefined = [];
        let unfilteredData = null;

        if (this.state.filteredDataSidebar) {
            unfilteredData = this.state.filteredDataSidebar;
        } else {
            unfilteredData = this.props.dataVimeo;
        }

        if (event.query.trim().length) {
            filteredData = unfilteredData?.filter((data) => {
                return data.name
                    .toLowerCase()
                    .includes(event.query.toLowerCase()) || this.doSearchTag(event.query.toLowerCase(), data);

            });
        }

        this.setState({ filteredData, searchTagsOnSidebar: false });
    }

    private doSearchTag (tagPartial: any, data: any) {
        let resp = null;

        data.tags.filter((tag: any) => {
            if (tag.toLowerCase().includes(tagPartial.trim().toLowerCase())) {
                resp = tag.toLowerCase().includes(tagPartial.trim().toLowerCase());
            }
        });

        return resp;
    }

    private doSearchSidebar (tag: any) {
        let filteredData: any = [];

        filteredData = this.props.dataVimeo?.filter((data) => {
            return data.tags?.includes(tag.trim());
        });

        if (tag.includes('All')) {
            this.setState({ searchTagsOnSidebar: false, active: true, item: tag });

            return this.props.dataVimeo;
        } else {
            this.setState({ searchTagsOnSidebar: true });
        }

        this.setState({ active: true, item: tag });

        return filteredData;
    }

    private handleClickSidebar = (e: React.MouseEvent<HTMLDivElement>) => {
        this.props.onClick?.(e);

        if ((e.target as HTMLElement)) {
            let filteredData = this.doSearchSidebar((e.target as HTMLElement).textContent);
            this.setState({ filteredDataSidebar: filteredData, filteredData, selectedVideo: null });
        }
    }

    private filterVideoData () {
        let searchData: any = [];

        if (!this.state.selectedVideo && this.state.filteredDataSidebar) {
            searchData = this.state.filteredDataSidebar;
        } else if (this.state.selectedVideo) {
            searchData = this.state.filteredData;
        } else {
            searchData = this.props.dataVimeo;
        }

        return searchData;

    }

    private getUniqueTags() {
        let tags = new Set();

        this.props.dataVimeo?.map((video) => {
            for (const item in video.tags) {
                tags.add(video.tags[item as any]);
            }
        });

        let tagsArray = Array.from(tags);

        return tagsArray.filter(tag => tag !== 'Suggested');
    }

    private handleClickSingleVideo = (e: any) => {
        // open vimeo page on ctr+click or middle click
        // this.renderTooltip();

        if (e.ctrlKey || e.button === 1) {
            // @ts-ignore
            window.open(this.state.singleVideo?.link, '_blank');
        }
    };

    private handleClickSearchClear = () => {
        this.setState({ selectedVideo: null });
    };

    private searchVideoData = (event: any) => {
        if (this.timer) {
            clearTimeout(this.timer);
        }
        this.timer = setTimeout(() => this.doSearch(event), 100);
    };

    private getVideosAndTags(tags: any, videos: any) {
        let tagItem: any = [];

        tags.forEach((tag: any) => {
            let indexVid = 0;
            let index = 0;
            videos.forEach((video: any) => {
                if (video.tags.includes('Suggested')) {
                    let tagsFiltered = video.tags.filter((tagSuggested: any) => tagSuggested !== 'Suggested');
                    if (tagsFiltered.toString().includes(tag) && indexVid <= 2) {
                        indexVid = indexVid + 1;
                        tagItem.push({ tag: tag, index: index, video: video });
                    }
                }
                index = index + 1;
            }

            );
        });

        return tagItem;
    }

    componentDidMount() {
        this.renderTooltip();
    }

    componentDidUpdate(prevProps: any, prevState: any) {
        if (prevState.filteredData !== this.state.filteredData || prevState.singleVideoView !== this.state.singleVideoView) {
            this.destroyTooltip();
            this.renderTooltip();
        }
    }

    componentWillUnmount() {
        this.destroyTooltip();
    }

    destroyTooltip() {
        // @ts-ignore
        this.state.tooltipsList?.forEach((tooltip: any) => {
            tooltip.destroy();
            tooltip = null;
        });
        this.setState({ tooltipsList: null });
    }

    renderTooltip() {
        const tooltipVideos: any = [];
        const videoList = document.querySelectorAll<HTMLElement>('.itg-video__title');
        let searchData = this.filterVideoData() || this.props.dataVimeo;
        videoList.forEach((e: HTMLElement, i: number) => {
            if (e.innerHTML?.length >= 42) {
                this.tooltip = tip({
                    target: e,
                    content: searchData[i].name,
                    options: { position: 'bottom' }
                });
                tooltipVideos.push(this.tooltip);
            }

        });
        this.setState({ tooltipsList: tooltipVideos });
    }

    render () {
        const { className } = this.props;
        const _className = `in-app-videos ${className}`;
        let searchData = this.filterVideoData() || this.props.dataVimeo;
        let tags = this.getUniqueTags();
        const dataLength = searchData?.length;
        let videosByTag = this.getVideosAndTags(tags, this.props.dataVimeo);
        let baseClass = !this.props.singleVideoViewSidebar ? 'single' : '';
        let bodyClass = classnames('in-app-videos__lower-inner-body', baseClass);
        let lowerBodyClass = classnames('in-app-videos__lower-body', baseClass);
        let videoCardClass = classnames('in-app-videos__body', baseClass);

        // @ts-ignore
        // @ts-ignore
        // @ts-ignore
        // @ts-ignore
        return (
            <div className={_className} onMouseDown={this.handleMouseDown} onClick={this.handleClickBackground}>
                <div className='in-app-videos__inner-container' >
                    <div className='in-app-videos__header'>
                        <div className='in-app-videos__title'> {'Video Tutorials'}
                            <button className='modal__header-icon' onClick={this.handleClick}>
                                <Icon light name='times'/>
                            </button>
                        </div>
                    </div>

                    <div className={lowerBodyClass}>
                        { this.props.sidebar && ((this.props.singleVideoViewSidebar && videosByTag) ||
                         !this.state.singleVideoView) &&
                            <InAppSidebar
                                tags={tags}
                                tagColors={this.props.tagColors}
                                singleVideoView={this.state.singleVideoView}
                                handleReturn={this.handleReturn}
                                active={this.state.active}
                                item={this.state.item}
                                size={this.state.singleVideoView}
                                dataVimeo={this.props.dataVimeo}
                                handleClickSidebar={this.handleClickSidebar}
                                handleVideoClick={this.handleVideoClick}
                                videosAndTags={videosByTag}
                            />
                        }

                        {this.state.singleVideoView && this.props.supportSingleVideoView ? <div className='in-app-videos__single-video-view'>
                            <SingleVideoView
                                key={1}
                                onClick={(e: any) => this.handleClickSingleVideo(e)}
                                onClickReturn={this.handleReturn}
                                // @ts-ignore
                                title={this.state.singleVideo?.name}
                                // @ts-ignore
                                date={this.state.singleVideo?.date}
                                // @ts-ignore
                                link={this.state.singleVideo?.link}
                                // @ts-ignore
                                tag={this.state.singleVideo?.tags}
                                tagColors={this.props.tagColors}
                                singleVideoSidebar= {this.props.singleVideoViewSidebar}
                                iframe={findIframes(this.state.singleVideoIndex, this.props.dataVimeo, true)}
                                // @ts-ignore
                                description={this.state.singleVideo?.description} />
                        </div> : <div className='single-video-view-none'></div> }

                        {!this.state.singleVideoView && <div className={bodyClass}>
                            <div className='in-app-videos__search-bar' >
                                <div className='search-container-in-app'>
                                    <AutoComplete
                                        value={this.state.selectedVideo}
                                        completeMethod={this.searchVideoData}
                                        field='name'
                                        placeholder={'Search by keywords...'}
                                        onChange={(e) => this.setState({ selectedVideo: e.value })}
                                        autoFocus
                                        {...this.props}
                                    />
                                    { !this.state.selectedVideo && <Icon regular name='search' className='dropdown-filter-icon-in-app-videos'/> }
                                    { this.state.selectedVideo && <Icon light name='times' onClick={() => this.handleClickSearchClear()}
                                        className='dialog__close-button-search'/>}
                                </div>
                                <span className='in-app-videos__results'> {`${dataLength} of ${dataLength} Results`}</span>
                            </div>

                            {searchData && !this.state.singleVideoView && <div className={videoCardClass}>
                                {
                                    searchData.map((video: any, index: any) => {
                                        return (
                                            <div className={'itc-videos'} key={ index }>
                                                <VideoCard
                                                    key={index}
                                                    className={'itg-video'}
                                                    title={video.name}
                                                    onClick={(e: any) => this.handleVideoClick(e, video, index)}
                                                    iframe={findIframes(index, this.props.dataVimeo, false)}
                                                    sidebar = {this.props.sidebar}
                                                    tags={video.tags}
                                                    tagColors={this.props.tagColors}
                                                    description={video.description} />
                                            </div>
                                        );
                                    })
                                }
                            </div>
                            }
                        </div>}
                    </div>
                </div>
            </div>
        );
    }
}
